import moment from 'moment';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get, includes } from 'lodash';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { ChanelConfig } from '../../../../configs/GlobalConfig';
import MessageHub from '../../../../core/signalr/SignalrMessageHub';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import Table from '../../../common/table/Table';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { REDUCER_NAME as WL_REDUCER_NAME } from '../reducer';
import TextBlink from '../../../common/table/TextBlink';
import TradingViewUrl from '../../../common/TradingViewUrl';
import { getColorPrice, getColorRefPrice } from '../../../helpers/Color';
import {
  getDataFollowKeyByDot,
  syncComponentSelector,
} from '../../../helpers/Common';
import {
  formatPercent,
  formatPrice,
  formatTextFloat,
  formatValue,
} from '../../../helpers/Text';
import { toggleConfirmPopupDelete } from '../reducer';
import CellHover from '../summary/CellHover';
import ConstSummary from '../summary/Const';
import CWBidAsk from '../summary/CWBidAsk';
import DayRange from '../summary/DayRange';
import PerformanceChartWrap from '../summary/PerformanceChartWrap';
import { listColumn } from './Const';
import { REDUCER_NAME, updateCoveredWarrantData } from './reducer';

const getBreakEvenPrice = item => {
  return (
    get(item, listColumn.EXERCISE_PRICE) +
    (get(item, 'closePrice') *
      get(item, listColumn.EXECUTION_RATE_COVERED_WARRANT)) /
      get(item, listColumn.EXECUTION_RATE_SHARE)
  );
};

class TableCoveredWarrant extends PureComponent {
  componentDidMount() {
    MessageHub.subscribe(ChanelConfig.CoveredWarrantChannel, this.onReceiveCW);
    MessageHub.subscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(
      ChanelConfig.CoveredWarrantChannel,
      this.onReceiveCW,
    );
    MessageHub.unsubscribe(ChanelConfig.BidAskChannel, this.onReceiveBidAsk);
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTicker);
  }

  onReceiveCW = data => {
    const { updateCoveredWarrantData, dataByCode } = this.props;
    const dispatchData = {};
    data.forEach(item => {
      const { organCode, ticker, ...restData } = item;

      dispatchData[organCode] = {
        ...dataByCode[organCode],
        ...restData,
      };
    });
    updateCoveredWarrantData(dispatchData);
  };

  onReceiveBidAsk = data => {
    const { ids, updateCoveredWarrantData, dataByCode } = this.props;
    const dispatchData = {};
    data.forEach(item => {
      if (ids.includes(item.organCode)) {
        dispatchData[item.organCode] = {
          ...dataByCode[item.organCode],
          ...item,
          organCode: dataByCode[item.organCode].organCode,
        };
      }
    });
    if (Object.keys(dispatchData).length) {
      updateCoveredWarrantData(dispatchData);
    }
  };

  onReceiveTicker = data => {
    const {
      dataByOrganCode,
      dataByCode,
      updateCoveredWarrantData,
    } = this.props;
    const dispatchData = {};
    data.forEach(item => {
      const warrantCode = dataByOrganCode[item.organCode];
      if (warrantCode) {
        dispatchData[warrantCode] = {
          ...dataByCode[warrantCode],
          orgMatchPrice: item.matchPrice,
          orgCeilingPrice: item.ceilingPrice,
          orgFloorPrice: item.floorPrice,
          orgReferencePrice: item.referencePrice,
          tradingDate: item.tradingDate,
        };
      }
    });
    if (Object.keys(dispatchData).length) {
      updateCoveredWarrantData(dispatchData);
    }
  };

  formatRate = num => {
    return num % 1 === 0 ? num : formatTextFloat(num);
  };

  getDataFromRedux = state => {
    return state[REDUCER_NAME].dataByCode;
  };

  getOrganizationFromOrganCode = organCode => {
    const { listOrganizationByOrganCode } = this.props;

    return listOrganizationByOrganCode[organCode] || {};
  };

  getSchema = () => {
    return Object.values(listColumn).map(key => {
      const commonItem = {
        key,
        title: `coveredWarrant.${key}`,
        render: text => <div className="pl-8 pr-8">{text}</div>,
      };

      if (key === listColumn.TICKER) {
        const { currentCoveredWarrant } = this.props;
        const isShowDeleteIcon =
          currentCoveredWarrant !== ConstSummary.defaultCoveredWarrant;
        return {
          ...commonItem,
          thStyle: {
            width: '140px',
          },
          render: (text, item) => (
            <CellHover
              isShowDeleteIcon={isShowDeleteIcon}
              handleDelete={() =>
                this.deleteCoveredWarrantCode(item.coveredWarrantCode)
              }
              isShowQuickIcon={false}
            >
              <div className="pl-10 pr-10">
                <TradingViewUrl code={text} /> {text}
              </div>
            </CellHover>
          ),
        };
      }

      if (key === listColumn.CONVERSION_RATE) {
        return {
          ...commonItem,
          render: (text, item) => {
            const warrantRate = this.formatRate(
              get(item, listColumn.EXECUTION_RATE_COVERED_WARRANT),
            );
            const shareRate = this.formatRate(
              get(item, listColumn.EXECUTION_RATE_SHARE),
            );

            return (
              <div className="pl-8 pr-8">{`${warrantRate}:${shareRate}`}</div>
            );
          },
        };
      }

      if ([listColumn.CEILING, listColumn.FLOOR].includes(key)) {
        return {
          ...commonItem,
          render: (text, item) => {
            const className =
              key === listColumn.CEILING ? 'text-s-color-6' : 'text-s-color-2';
            return (
              <TextBlink
                item={item}
                tradingDate={listColumn.TRADING_DATE}
                className={className}
              >
                {formatTextFloat(
                  formatPrice(text),
                  2,
                  key !== listColumn.CHANGE,
                )}
              </TextBlink>
            );
          },
        };
      }

      if (
        [
          listColumn.ISSUE_PRICE,
          listColumn.AVG_PRICE_1W,
          listColumn.EXERCISE_PRICE,
          listColumn.VOLUME,
        ].includes(key)
      ) {
        return {
          ...commonItem,
          render: (text, item) => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatPrice(text))}
            </TextBlink>
          ),
        };
      }

      if (key === listColumn.CURRENT_PRICE) {
        return {
          ...commonItem,
          render: (text, item) => {
            let className = getColorPrice(
              text,
              getDataFollowKeyByDot(item, 'orgReferencePrice'),
              getDataFollowKeyByDot(item, 'orgCeilingPrice'),
              getDataFollowKeyByDot(item, 'orgFloorPrice'),
              'text',
            );
            if (!text) {
              className = '';
            }

            return (
              <TextBlink
                item={item}
                tradingDate={listColumn.TRADING_DATE}
                className={className}
              >
                {formatTextFloat(
                  formatPrice(text),
                  2,
                  key !== listColumn.CHANGE,
                )}
              </TextBlink>
            );
          },
        };
      }

      if (
        [
          listColumn.PRICE,
          listColumn.CHANGE,
          listColumn.OPEN,
          listColumn.HIGH,
          listColumn.LOW,
          listColumn.FR_BUY_VOL,
          listColumn.FR_SELL_VOL,
          listColumn.PUT_THROUGH_PRICE,
        ].includes(key)
      ) {
        return {
          ...commonItem,
          render: (text, item) => {
            const compareValue =
              key === listColumn.CHANGE ? get(item, listColumn.PRICE) : text;
            let className = getColorPrice(
              compareValue,
              getDataFollowKeyByDot(item, listColumn.REF),
              getDataFollowKeyByDot(item, listColumn.CEILING),
              getDataFollowKeyByDot(item, listColumn.FLOOR),
              'text',
            );
            if (
              (!text ||
                [listColumn.FR_BUY_VOL, listColumn.FR_SELL_VOL].includes(
                  key,
                )) &&
              listColumn.CHANGE !== key
            ) {
              className = '';
            }

            return (
              <TextBlink
                item={item}
                tradingDate={listColumn.TRADING_DATE}
                className={className}
              >
                {formatTextFloat(
                  formatPrice(text),
                  2,
                  key !== listColumn.CHANGE,
                )}
              </TextBlink>
            );
          },
        };
      }

      if (key === listColumn.REF) {
        return {
          ...commonItem,
          render: (text, item) => (
            <TextBlink
              item={item}
              tradingDate={listColumn.TRADING_DATE}
              className={getColorRefPrice(
                formatTextFloat(formatPrice(text)),
                'text',
              )}
            >
              {formatTextFloat(formatPrice(text), 2, true)}
            </TextBlink>
          ),
        };
      }

      if (key === listColumn.PERCENT_PRICE_CHANGE) {
        return {
          ...commonItem,
          render: (text, item) => {
            const className = getColorPrice(
              getDataFollowKeyByDot(item, listColumn.PRICE),
              getDataFollowKeyByDot(item, listColumn.REF),
              getDataFollowKeyByDot(item, listColumn.CEILING),
              getDataFollowKeyByDot(item, listColumn.FLOOR),
              'text',
            );
            return (
              <TextBlink
                item={item}
                className={className}
                tradingDate={listColumn.TRADING_DATE}
              >
                {`${formatTextFloat(formatPercent(text))}%`}
              </TextBlink>
            );
          },
        };
      }

      if (key === listColumn.PUT_THROUGH_VOL) {
        return {
          ...commonItem,
          render: text => (
            <div className="pl-8 pr-8">
              {formatTextFloat(formatPrice(text), 2, true)}
            </div>
          ),
        };
      }

      if (key === listColumn.PUT_THROUGH_VALUE) {
        return {
          ...commonItem,
          render: text => (
            <div className="pl-8 pr-8">
              {formatTextFloat(formatValue(text), 2, true)}
            </div>
          ),
        };
      }

      if (key === listColumn.VALUE) {
        return {
          ...commonItem,
          render: text => (
            <div className="pl-8 pr-8">
              {formatTextFloat(formatValue(text))}
            </div>
          ),
        };
      }

      if (
        [
          listColumn.EXPIRE_DATE,
          listColumn.LAST_TRADING_DATE,
          listColumn.LISTING_DATE,
        ].includes(key)
      ) {
        return {
          ...commonItem,
          render: text => {
            return <div className="pl-8 pr-8">{moment(text).format('l')}</div>;
          },
        };
      }

      if (key === listColumn.DAY_RANGE) {
        return {
          disableSort: true,
          disableResize: true,
          thStyle: { width: '153px', textAlign: 'center' },
          ...commonItem,
          render: (text, item) => {
            const lowestPrice = formatPrice(
              getDataFollowKeyByDot(item, listColumn.LOW),
            );
            const highestPrice = formatPrice(
              getDataFollowKeyByDot(item, listColumn.HIGH),
            );
            const matchPrice = formatPrice(
              getDataFollowKeyByDot(item, listColumn.PRICE),
            );
            const referencePrice = formatPrice(
              getDataFollowKeyByDot(item, listColumn.REF),
            );
            if (
              includes(
                [lowestPrice, highestPrice, matchPrice, referencePrice],
                '--',
              )
            ) {
              return;
            }
            return (
              <div style={{ padding: '0 8px', width: '150px' }}>
                <DayRange
                  key={listColumn.DAY_RANGE}
                  lowestPrice={lowestPrice}
                  highestPrice={highestPrice}
                  matchPrice={matchPrice}
                  referencePrice={referencePrice}
                />
              </div>
            );
          },
        };
      }

      if (key === listColumn.BASIS) {
        return {
          ...commonItem,
          render: (text, item) => {
            const result =
              get(item, listColumn.AVG_PRICE_1W) -
              get(item, listColumn.EXERCISE_PRICE);

            return (
              <div className="pl-8 pr-8">
                {formatTextFloat(formatPrice(result))}
              </div>
            );
          },
        };
      }

      if (key === listColumn.PERFORMANCE) {
        return {
          disableSort: true,
          disableResize: true,
          ...commonItem,
          tdClassName: 'fix-width-chart',
          thStyle: { textAlign: 'center', width: '125px' },
          thTooltip: I18n.t('table.market.performance'),
          render: (text, item) => {
            return (
              <div style={{ paddingRight: 10, paddingLeft: 10 }}>
                <div style={{ margin: '0 auto' }}>
                  <PerformanceChartWrap
                    ticker={get(item, listColumn.COVERED_WARRANT_ORGAN_CODE)}
                  />
                </div>
              </div>
            );
          },
        };
      }

      if ([listColumn.FR_BUY_VAL, listColumn.FR_SELL_VAL].includes(key)) {
        const resultKey =
          key === listColumn.FR_BUY_VAL
            ? listColumn.FR_BUY_VOL
            : listColumn.FR_SELL_VOL;
        return {
          ...commonItem,
          render: (text, item) => (
            <div className="pl-8 pr-8">
              {formatTextFloat(
                formatValue(get(item, resultKey) * get(item, listColumn.PRICE)),
                2,
                true,
              )}
            </div>
          ),
        };
      }

      if (key === listColumn.PREMIUM) {
        return {
          ...commonItem,
          render: (text, item) => {
            const avgPrice1W = get(item, listColumn.AVG_PRICE_1W);
            const breakEvenPrice = getBreakEvenPrice(item);
            const percent = avgPrice1W / breakEvenPrice - 1;
            let className = 'text-s-color-4';
            if (percent > 0) {
              className = 'text-s-color-5';
            }
            if (percent < 0) {
              className = 'text-s-color-3';
            }

            return (
              <div className={`pl-8 pr-8 ${className}`}>{`${formatTextFloat(
                formatPercent(percent),
              )}%`}</div>
            );
          },
        };
      }

      if (key === listColumn.SYMBOL_TICKER) {
        return {
          ...commonItem,
          valueFromItem: item => {
            const organization = this.getOrganizationFromOrganCode(
              get(item, listColumn.ORGAN_CODE),
            );

            return organization.ticker;
          },
          render: (text, item) => {
            const organization = this.getOrganizationFromOrganCode(
              get(item, listColumn.ORGAN_CODE),
            );

            return <div className="pl-8 pr-8">{organization.ticker}</div>;
          },
        };
      }

      if (includes([listColumn.BEST_1_BID, listColumn.BEST_1_ASK], key)) {
        return {
          ...commonItem,
          render: (text, item) => {
            return <CWBidAsk text={text} item={item} itemKey={key} />;
          },
        };
      }

      if (key === listColumn.BREAK_EVEN_PRICE) {
        return {
          ...commonItem,
          render: (text, item) => {
            const breakEvenPrice = getBreakEvenPrice(item);

            return (
              <div className="pl-8 pr-8">
                {formatTextFloat(formatPrice(breakEvenPrice), 2, true)}
              </div>
            );
          },
        };
      }

      return {
        ...commonItem,
      };
    });
  };

  deleteCoveredWarrantCode = code => {
    const { toggleConfirmPopupDelete } = this.props;
    toggleConfirmPopupDelete(true, code);
  };

  onRowClick = code => {
    const { coveredWarrantDataByCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: coveredWarrantDataByCode[code],
    });
  };

  render() {
    const { ids, isLoading, hideColumns } = this.props;

    return (
      <Table
        clickRow={this.onRowClick}
        columnDraggable={true}
        isLoading={isLoading}
        ids={ids}
        getDataFromRedux={this.getDataFromRedux}
        schema={this.getSchema()}
        hideColumns={hideColumns}
      />
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  ids: state[REDUCER_NAME].codes,
  dataByCode: state[REDUCER_NAME].dataByCode,
  dataByOrganCode: state[REDUCER_NAME].dataByOrganCode,
  isLoading: state[REDUCER_NAME].isLoading,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  hideColumns: state[REDUCER_NAME].listHideColumnIndex,
  currentCoveredWarrant: state[WL_REDUCER_NAME].currentCoveredWarrant,
  coveredWarrantDataByCode: state[COMMON_REDUCER_NAME].coveredWarrantDataByCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  toggleConfirmPopupDelete,
  updateCoveredWarrantData,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TableCoveredWarrant);
